module.exports = __webpack_public_path__ + "static/media/bjork_cover.787d3ff5.png";